import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
interface ReferProps extends React.SVGProps<SVGSVGElement> {}
const _Refer = (props: ReferProps) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_Refer" data-sentry-source-file="Refer.tsx">
    <path d="M11.0991 2.54974C12.4974 3.94808 11.7106 7.00204 9.34166 9.37096C6.97274 11.7399 3.91878 12.5267 2.52044 11.1284C1.1221 9.73002 1.90892 6.67605 4.27784 4.30713C6.64676 1.93821 9.70072 1.1514 11.0991 2.54974ZM11.0991 2.54974L13.2887 4.73878C14.6874 6.13744 13.9007 9.19144 11.5314 11.5601C9.16202 13.9288 6.10869 14.7154 4.71002 13.3174L2.40602 11.0134" stroke="currentColor" strokeMiterlimit="10" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Refer.tsx" />
  </svg>;
const Refer = memo(_Refer);
export const ReferWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="ReferWithIconTag" data-sentry-source-file="Refer.tsx">
    <Refer className={className} data-sentry-element="Refer" data-sentry-source-file="Refer.tsx" />
  </i>;
export default Refer;